import axios from 'axios';
import { WebServiceHosts, AuthHeader } from './siteConfigConstants';

const webStoreUri = `${WebServiceHosts.WebStore}/api/`;

export default axios.create({
    baseURL: webStoreUri,
    headers: {
        Authorization: AuthHeader,
        'Content-Type': 'application/json',
    },
});
